import { Component, Input } from '@angular/core';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'progress-bar',
  templateUrl: 'progress-bar.html'
})
export class ProgressBar {

  @Input('progress') progress = 0;
  @Input('label') label;

  event: any;

  constructor(params: NavParams) {
    this.event = params.get('event');
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/progress-bar/progress-bar.ts